module.exports = __webpack_public_path__ + "img/icon_kyksjsk.70e0dac3.png";